import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { get_states, term_update, terms_edit } from "../../../apis/Common";
import { Button } from "semantic-ui-react";
import { lessonWeeks } from "./termWeeks";
const EditTerms = ({
  isModalOpen,
  setIsModalOpen,
  duplicateItemId,
  setStatus,
}) => {
  // const [checkValidation, setCheckValidation] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm({
    defaultValues: {
      state: "" // initial empty value
    }
  });
  const [statelist, setStateList] = useState([]);
  const [show, setShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Only a change to a date refills the weeks; opening the form keeps the
  // saved number (2026 Term 4 has 11 lessons, which the old formula made 10).
  const fillWeeks = () => {
    const weeks = lessonWeeks(getValues("start_date"), getValues("end_date"));
    if (weeks) setValue("max_week", weeks, { shouldValidate: true });
  };
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    console.log("going");
    // if (!checkValidation) {
    //     console.log('invalid');
    // }
    // else {
    const formattedData = {
      ...data,
      end_date: data.end_date || null,
      max_week: Number(data.max_week),
    };
    let result = await term_update(duplicateItemId, formattedData);
    if (result?.status) {
      setIsModalOpen(false);
      setStatus("");
      window.location.reload();
      return navigate("/admin/term/all");
    }
    setIsSubmitting(false);
  };
  // }
  useEffect(() => {
    async function get_data() {
      const result = await terms_edit(duplicateItemId);
      if (result?.data?.length > 0) {
        const { name, year, start_date, end_date, status, state, max_week } =
        result?.data[0];
        setValue("year", year);
        setValue("name", name);
        setValue("start_date", start_date);
        setValue("end_date", end_date || "");
        setValue("status", status);
         setValue("state", state);
        setValue("max_week", max_week);
      }
    }
    if (isModalOpen) {
      get_data();
    }
  }, [isModalOpen, duplicateItemId]);

  useEffect(() => {
    return setIsModalOpen(false);
  }, []);
  // const regexPattern = /^term\s?(1[0-2]|[1-9])$/;
  // const checkregex = (name) => {
  //     if (regexPattern.test(name)) {
  //         console.log("Valid string");
  //         setCheckValidation(true);
  //     } else {
  //         setCheckValidation(false);
  //     }
  // }
  useEffect(() => {
    const fetchData = async () => {
      const stateList= await get_states();
      setStateList(stateList?.data);
    };
    fetchData();
  }, []);
  return (
    <>
      <div
        className={`modal fade ${isModalOpen ? "show" : ""}`}
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden={isModalOpen}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mx-auto modal-title mt-2" id="staticBackdropLabel">
                Edit Data
              </h5>
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setStatus("");
                }}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="form-horizontal"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Year *</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="e.g. 2026"
                        {...register("year", { required: true })}
                      />
                    </div>
                    {errors.year && errors.year.type === "required" && (
                      <span className="validation-error">This is required</span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Term Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Term Name"
                        {...register("name", { required: true })}
                      />
                    </div>
                    {errors.name && errors.name.type === "required" && (
                      <span className="validation-error">This is required</span>
                    )}
                    {/* {checkValidation ? '' : <span className="validation-error">Term name should be term and number between 0 to 12</span>} */}
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>State *</label>
                      <select
                        className="form-select form-control"
                        // value={"New South Wales"}
                        {...register("state", { required: "This is required" })}
                      >
                        {/* <option value="">Choose State</option> */}
                        {/* <option value="New south wales">New South Wales</option>
                        <option value="Australian Capital Territory">
                          Australian Capital Territory
                        </option>
                        <option value="Northern Territory">
                          Northern Territory
                        </option>
                        <option value="Queensland">Queensland</option>
                        <option value="South Australia">South Australia</option>
                        <option value="Tasmania">Tasmania</option>
                        <option value="Victoria">Victoria</option>
                        <option value="Western Australia">
                          Western Australia
                        </option> */}
                         {statelist?.length > 0
                        ? [
                            <option value="">Choose State</option>,
                            statelist?.map((elem) => {
                              return (
                                <option value={elem?.id}>
                                  {elem?.name}
                                </option>
                              );
                            }),
                          ]
                        : [
                            <option value="">State not available</option>,
                          ]}
                      </select>
                      {errors.state && (
                        <span className="validation-error">
                          This is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Start Date *</label>
                      <input
                        type="date"
                        className="form-control"
                        max="9999-12-31"
                        {...register("start_date", {
                          required: "This is required",
                          onChange: fillWeeks,
                        })}
                      />
                    </div>
                    {errors.start_date && (
                      <span className="validation-error">{errors.start_date.message}</span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max="9999-12-31"
                        {...register("end_date", {
                          onChange: fillWeeks,
                          validate: (value) =>
                            !value || value >= getValues("start_date") || "The end date is before the start date.",
                        })}
                      />
                      <small className="d-block text-muted mt-1">
                        The last lesson day. Empty: the term ends after the weeks below.
                      </small>
                    </div>
                    {errors.end_date && (
                      <span className="validation-error">{errors.end_date.message}</span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Weeks *</label>
                      <input
                        type="number"
                        className="form-control"
                        min="1"
                        max="53"
                        {...register("max_week", {
                          required: "This is required",
                          min: { value: 1, message: "At least 1 week." },
                          max: { value: 53, message: "At most 53 weeks." },
                        })}
                      />
                      <small className="d-block text-muted mt-1">
                        Weekly lessons in the term. Changing a date refills it.
                      </small>
                    </div>
                    {errors.max_week && (
                      <span className="validation-error">{errors.max_week.message}</span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>status</label>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          {...register("status")}
                          id="inlineRadio1"
                          value="1"
                        />
                        <label class="form-check-label" for="inlineRadio1">
                          Active
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          {...register("status")}
                          id="inlineRadio2"
                          value="0"
                        />
                        <label class="form-check-label" for="inlineRadio2">
                          Inactive
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    type="submit"
                    className="btn button"
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditTerms;
